import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Pagination, Table } from 'src/app/shared/types';
import { TICKET_STATUS_MAPPING, CAPTAIN_ISSUES_SUB_REASONS} from 'src/app/shared/constants';
import {
  collectBookingIds,
  createTicketLinkTableData,
  createTicketOrderIdCells,
  createTicketTableData,
  filterCaptainIssueTickets,
  mapBookingIdToRdOrderId,
  TICKET_V2_ALL_PAGES,
} from 'src/app/shared/ticket-table.helper';


import { UserTicketingService } from '../../user-tickets.service';
import { HelperService } from 'src/app/helper.service';
import { OrderService } from 'src/app/order-service.service';

@Component({
  selector: 'app-tickets-against-captain',
  templateUrl: './tickets-against-captain.component.html',
  styleUrls: ['./tickets-against-captain.component.css']
})
export class TicketsAgainstCaptainComponent implements OnInit {

  @Input() captainId: any;
  @Input() captainDetailsToggleableHeaders: string[];
  @Output() toggleHeaders: EventEmitter<any> = new EventEmitter();
  captainTickets: Table;
  dataLoaded = false;
  captainIssues = CAPTAIN_ISSUES_SUB_REASONS;

  constructor(
    public orderService: OrderService,
    public ticketingService: UserTicketingService
  ) { }

  ngOnInit() {
    this.declareTable();
  }

  declareTable() {
    this.captainTickets = new Table({
      toggleableHeaders: this.captainDetailsToggleableHeaders,
      headers: {
        date: 'Created Date',
        ticketId: 'Ticket ID',
        rdOrderId: 'RD Order ID',
        orderId: 'Order ID',
        subReason: 'Sub Reason',
        service: 'Service',
        status: 'Status'
      },
      pagination: new Pagination(0, 10, 30, [10,15,20], 0,true),
      selectedHeader: 7,
      defaultError: 'No Tickets found',
      onRefresh: () => {
        this.captainTickets = null;
        this.ngOnInit();
      },
      data: []
    });
    this.getTickets();
  }

  async getTickets(pageNumber = 1, perPage = 10) {
    this.dataLoaded = false;
    const orderPagination = new Pagination(0, 200, 200, [10,50,100],0, true);
    try {
      const currentDate = new Date();
      const fromDate = new Date(new Date(currentDate).setDate(new Date(currentDate).getDate() - 90));
      const appliedFilters = {
        duration: {
          start: fromDate,
          end: currentDate,
        },
        fromDate,
        currentDate,
        cities: [],
        services: [],
        status: '',
      };
      await this.orderService.getOrdersForCaptain(this.captainId, orderPagination, fromDate, currentDate, "captain", appliedFilters).subscribe(async data=>
        {
          const orders = data.orders || [];
          const bookingIds = collectBookingIds(orders);
          const rdOrderIdByBookingId = mapBookingIdToRdOrderId(orders);
          const query = {
              "booking_id": bookingIds
          };
          const queryString = JSON.stringify(query);
          const response : any = await this.ticketingService.fetchUserTicketsV2(
            this.captainId, 'customer', queryString, pageNumber, TICKET_V2_ALL_PAGES
          ).toPromise();
          this.dataLoaded = true;
          if (response && response.tickets) {
            const tickets = filterCaptainIssueTickets(response.tickets, this.captainIssues);
            this.captainTickets.data = this.formatTicketsAgainstCaptain(tickets, rdOrderIdByBookingId);
          }
        });
      
    } catch(error) {
      console.log('Error while fetching tickets for captain');
      this.dataLoaded = true;
    }
  }

  formatTicketsAgainstCaptain(ticketsAgainstCaptain = [], rdOrderIdByBookingId = {}) {
    if (ticketsAgainstCaptain.length > 25) ticketsAgainstCaptain.length = 25;
    const formatedTickets = [];
    ticketsAgainstCaptain.map((item) => {
      const ticket = {
        date: createTicketTableData(HelperService.dateString(item.created_at)),
        ticketId: createTicketLinkTableData(item.ticket_id, item.redirection_url),
        ...createTicketOrderIdCells(item, rdOrderIdByBookingId[item.booking_id]),
        subReason: createTicketTableData(item.sub_reason918254 || ''),
        service: createTicketTableData(item.service || ''),
        status: createTicketTableData(TICKET_STATUS_MAPPING[item.status] || '')
      }
      formatedTickets.push(ticket);
    })

    return formatedTickets;
  }

  changeInHeader(header) {
    this.toggleHeaders.emit(header);
  }

  onPaginationChange(event) {
    this.getTickets((event.pageNo + 1), event.perPage);
  }
}
